import {
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

const LegalNotesContainer = styled.section`
    margin-top: ${(props) => props.theme.size.static500};
    padding-top: ${(props) => props.theme.size.static350};
    border-top: ${(props) => props.theme.size.border.default} solid
        ${(props) => props.theme.colors.border.divider};
`

const LegalNotesText = styled.div`
    overflow-wrap: anywhere;

    p {
        margin: 0;
    }

    /* The layer containers hide \`:empty\` elements, \`<br>\` of the CMS copy included */
    && br {
        display: inline;
    }
`

export interface FormPromotionLegalNotesProps {
    legalNotes: string
}

/**
 * Legal notes of the promotion the quotation is requested for, shown at the
 * bottom of the form without a visible title: the section is named for
 * assistive technologies only.
 */
export function FormPromotionLegalNotes({
    legalNotes,
}: FormPromotionLegalNotesProps): React.JSX.Element {
    const {t} = useTranslation('app')

    return (
        <LegalNotesContainer
            aria-label={t('coupon.couponRequest.legalNotesTitle')}
        >
            <Text tag={TextTag.div} appearance={TokenTextAppearance.copy100}>
                <LegalNotesText
                    dangerouslySetInnerHTML={{
                        __html: legalNotes,
                    }}
                />
            </Text>
        </LegalNotesContainer>
    )
}
